const UUID_V4_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const VISITOR_TOKEN_KEY = 'rvn_vid';
const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;
function generateUUIDv4() {
    if (typeof (crypto === null || crypto === void 0 ? void 0 : crypto.randomUUID) === 'function')
        return crypto.randomUUID();
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
function persistVisitorToken(token) {
    try {
        document.cookie = `${VISITOR_TOKEN_KEY}=${encodeURIComponent(token)}; path=/; max-age=${ONE_YEAR_SECONDS}; SameSite=Lax; Secure`;
    }
    catch (_a) {
        // el documento puede estar sandboxeado sin allow-same-origin (p.ej. navegadores in-app), sin acceso a cookies
    }
}
export function getVisitorToken() {
    const params = new URLSearchParams(window.location.search);
    const rvt = params.get('rvt');
    if (rvt && UUID_V4_REGEX.test(rvt)) {
        persistVisitorToken(rvt);
        return rvt;
    }
    try {
        const match = document.cookie.match(new RegExp(`(?:^|; )${VISITOR_TOKEN_KEY}=([^;]*)`));
        if (match)
            return decodeURIComponent(match[1]);
    }
    catch (_a) {
        // el documento puede estar sandboxeado sin allow-same-origin (p.ej. navegadores in-app), sin acceso a cookies
    }
    const token = generateUUIDv4();
    persistVisitorToken(token);
    return token;
}
export function getSharedCookieDomain() {
    const parts = window.location.hostname.split('.');
    return parts.length > 2 ? '.' + parts.slice(-2).join('.') : '.' + window.location.hostname;
}
export function getPopupCookieKey(popupId, account) {
    const sanitizedAccount = (account === null || account === void 0 ? void 0 : account.replace(/[^a-zA-Z0-9_-]/g, '_')) || 'unknown';
    return `rvn_popup_${sanitizedAccount}_${popupId}`;
}
export function isPopupShownViaCookie(popupId, account) {
    const key = getPopupCookieKey(popupId, account);
    try {
        const match = document.cookie.match(new RegExp(`(?:^|; )${key}=([^;]*)`));
        if (!match)
            return false;
        const value = decodeURIComponent(match[1]);
        if (value === 'once')
            return true;
        return new Date(value) > new Date();
    }
    catch (_a) {
        // el documento puede estar sandboxeado sin allow-same-origin (p.ej. navegadores in-app), sin acceso a cookies
        return false;
    }
}
export function setPopupShownViaCookie(popupId, expiredAt, account) {
    const key = getPopupCookieKey(popupId, account);
    const value = expiredAt ? expiredAt.toISOString() : 'once';
    const domain = getSharedCookieDomain();
    // maxAge se define según el expiredAt, si no hay expiredAt (es 'once') se define un maxAge por defecto de 1 día
    const maxAge = expiredAt
        ? Math.max(1, Math.floor((expiredAt.getTime() - Date.now()) / 1000))
        : 60 * 60 * 24;
    try {
        document.cookie = `${key}=${encodeURIComponent(value)}; domain=${domain}; path=/; max-age=${maxAge}; SameSite=Lax; Secure`;
    }
    catch (_a) {
        // el documento puede estar sandboxeado sin allow-same-origin (p.ej. navegadores in-app), sin acceso a cookies
    }
}
export function isPopupViewStateActive(state) {
    if (!(state === null || state === void 0 ? void 0 : state.shown))
        return false;
    if (state.expiresAt === null)
        return true;
    return new Date(state.expiresAt) > new Date();
}
